import { SUCCESS, FAILED, REQUEST } from 'crom-api-constants'

export const REFRESH_GROUPS = {
    REFRESH: 'REFRESH',
    GROUP_STACK: 'GROUP_STACK',
    GROUP_MONITORING: 'GROUP_MONITORING',
}

export const REFRESH_FAVOURITES = 'REFRESH_FAVOURITES'
export const LOAD_FAVOURITES_REQUEST_SUCCESS = `LOAD_FAVOURITES_${REQUEST}_${SUCCESS}`
export const LOAD_FAVOURITES_REQUEST_FAILED = `LOAD_FAVOURITES_${REQUEST}_${FAILED}`

export const REFRESH_ENTITY_STACK_HISTORY = 'REFRESH_ENTITY_STACK_HISTORY'

export const NO_REFRESH = 'NO_REFRESH'

export const CHANGE_OLD_ENTITY_STACK_TAB = 'CHANGE_OLD_ENTITY_STACK_TAB'
export const CHANGE_NEW_ENTITY_STACK_TAB = 'CHANGE_NEW_ENTITY_STACK_TAB'

export const SOCKET_SEARCH_RESULTS = 'SOCKET_SEARCH_RESULTS'
export const SOCKET_SEARCH_RESULTS_OLD = 'SOCKET_SEARCH_RESULTS_OLD'

export const WS_CHANGE_MODULE_TAB = 'WS_CHANGE_MODULE_TAB'
export const WS_OPEN_REPORT = 'WS_OPEN_REPORT'
export const WS_OPEN_PORTFOLIO = 'WS_OPEN_PORTFOLIO'
